export default __webpack_public_path__ + "static/media/logo_archdiocese_transparent.976ba66d.png";